import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { setUsuarioLogin } from '../actions';
import { acceso, getGenerales } from '../service/Usuario'
import { Toast } from 'primereact/toast';

export const Login = () => {

    const responseUser = { token: '', email: '',idRol:'',idUsuario:'',rolNombre:'',foto:'',superusuario:false ,permisos:{}, colegios: [], anios: [], general: [],version:'' };

    const history = useHistory();
    const [usuario, setUsuario] = useState({ name: '', clave: '' });
    const [submitted, setSubmitted] = useState(false);
    const dispatch = useDispatch();
    const toast = useRef(null);
    const [loadingButton, setLoadingButton] = useState(false);

    useEffect(() => {
        // setUsuario({name:'',clave:''});
        // console.log(usuario); 

    }, [usuario]);



    const onInputChange = (e, name) => {

        const val = (e.target && e.target.value) || '';
        let _usuario = { ...usuario };
        _usuario[`${name}`] = val;
        setUsuario(_usuario);
    }

    const validateLogin = async () => {

        setLoadingButton(true);
        setSubmitted(true);

        if (usuario.name.trim()) {
    
            var data = await acceso(usuario.name, usuario.clave);

            if (data.error == 0) {
           
                responseUser.token = data.token;
                responseUser.email = data.usuario.email;
                responseUser.colegios = data.colegios;
                responseUser.anios = data.anios;
                responseUser.idRol = data.usuario.idrol;
                responseUser.idUsuario = data.usuario.idusuario;
                responseUser.rolNombre = data.usuario.rol_nombre;
                responseUser.foto = data.usuario.foto===undefined || data.usuario.foto===null ? '' : data.usuario.foto;
                responseUser.permisos = data.permisos;
                responseUser.superusuario = data.usuario.idrol==1 ? true : false;
                var dataG = await getGenerales(responseUser.token);
                responseUser.general = dataG;
                responseUser.version = process.env.REACT_APP_VERSION;
                localStorage.setItem('dat', JSON.stringify(responseUser));
                dispatch(setUsuarioLogin(responseUser));
                //setLoadingButton(false);
                history.push('/')

            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 3000 });
                } else {
                    console.log('Error');
                }
                setLoadingButton(false);
            }

        }

    }

    return (
        <div className="login-body-center">
            <Toast ref={toast} />
            <div className="card login-panel-center p-fluid">
                <div className="login-panel-content-center">
                    <div className="p-grid">
                        <div className="p-col-12">
                            <img src="assets/layout/images/logo.png" alt="avalon-layout" style={{ width: '300px' }} />
                        </div>

                        <div className="p-col-12" style={{ textAlign: 'left' }}>
                            <label className="login-label">Usuario</label>
                            <div className="login-input">
                                <InputText placeholder="Username" value={usuario.name} onChange={(e) => onInputChange(e, 'name')} required autoFocus className={classNames({ 'p-invalid': submitted && !usuario.name })} />
                                {submitted && !usuario.name && <small className="p-invalid">requerido.</small>}
                            </div>
                        </div>
                        <div className="p-col-12" style={{ textAlign: 'left' }}>
                            <label className="login-label">Contraseña</label>
                            <div className="login-input">
                                <Password placeholder="Password" value={usuario.clave} onChange={(e) => onInputChange(e, 'clave')} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-6 button-pane">
                            <Button loading={loadingButton} label="Ingresar" onClick={validateLogin} />
                        </div>
                        <div className="p-col-12 p-md-6 link-pane-center">
                            <button className="p-link">Recuperar Contraseña?</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
